import { useMediaQuery } from "@mui/material";
import { Theme } from "@mui/material/styles";

function useIsMobileView(): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"));
}

export default useIsMobileView;
